module.exports = __webpack_public_path__ + "img/link06_sp.79f6b2ff.png";